import i18next from 'i18next'
import { ReactElement, ReactNode } from 'react'
import { ButtonBase, ButtonVariant, ModalBase, ModalBaseButtons } from '../../atoms'

export interface Props {
  questionText: string
  buttonVariant?: ButtonVariant
  description?: ReactNode
  open?: boolean
  cancel?: string
  confirm?: string
  onClose: () => void
  onConfirmLoading?: boolean
  onConfirm: () => void
  modalBackgroundClassName?: string
}

export function ModalConfirm(props: Props): ReactElement {
  return (
    <ModalBase
      open={props.open}
      onClose={props.onClose}
      title={props.questionText}
      aria-title={props.questionText}
      description={props.description}
      modalBackgroundClassName={props.modalBackgroundClassName}
      noPaddingBelowDescription
      className="w-full max-w-xl"
    >
      <ModalBaseButtons>
        <ButtonBase type="button" variant="secondary" onClick={props.onClose}>
          {props.cancel ?? i18next.t('glow.cancel')}
        </ButtonBase>
        <ButtonBase
          type="button"
          isLoading={props.onConfirmLoading}
          variant={props.buttonVariant ?? 'primary'}
          onClick={props.onConfirm}
        >
          {props.confirm ?? i18next.t('glow.confirm')}
        </ButtonBase>
      </ModalBaseButtons>
    </ModalBase>
  )
}
